import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController, Loading } from 'ionic-angular';
import * as page from '../../pages/pages';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {ecomBadgesApi} from './../../api/ecom/ecomApi';
import {ApiConfig} from '../../shared/api-config.service'
import {AppConfig} from '../../shared/app-config.service'
import {LoggerService} from '../../shared/logger.service'
import { Storage } from '@ionic/storage';

@Component({
	selector: 'page-badges',
	templateUrl: 'badges.html',
	providers: [ecomBadgesApi, ApiConfig, LoggerService,AppConfig]
})
export class BadgesPage {

	userId:number;
	userBadges: any = [];
	zeroData: boolean = false;
	displayData: boolean = false;

	constructor(
		public navCtrl: NavController,
      	private ecomBadgesApi: ecomBadgesApi, 
      	private loadingCtrl: LoadingController, 
		private alertCtrl: AlertController,
		private log: LoggerService,
      	private storage: Storage
		) {
			this.storage.get('userId').then(data => {
				this.userId = Number(data);
			});
			
		}

	ionViewDidLoad() {		
		let loader = this.loadingCtrl.create();
		loader.present().then(()=>{
			this.ecomBadgesApi.GetAllEarnersBadges(this.userId).subscribe(
				badges => {
					this.userBadges = badges;
					console.log(badges);
					if(this.userBadges.length == 0){
						this.zeroData = true;
					}
					else{					
						this.displayData = true;
					}
					loader.dismiss();
				},
				error => {
					this.log.error(error);
					if(error){
						this.zeroData = true;
						this.displayData = false;
					}
					loader.dismiss();
				}
			
			);
		});		
			

	}

	

}



// WEBPACK FOOTER //
// ./src/pages/badges/badges.ts